import { createBrowserRouter } from "react-router-dom";
import { App } from "./App";
import { Landing } from "./pages/Landing";
import { Dashboard } from "./pages/Dashboard";
import { Create } from "./pages/Create";
import { Pfp } from "./pages/Pfp";
import { Mint1of1 } from "./pages/Mint1of1";
import { PublicMint } from "./pages/PublicMint";
import { TokenDetail } from "./pages/TokenDetail";
import { Creator } from "./pages/Creator";
import { Claim } from "./pages/Claim";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <Landing /> },
      { path: "dashboard", element: <Dashboard /> },
      { path: "create", element: <Create /> },
      { path: "pfp", element: <Pfp /> },
      { path: "mint", element: <Mint1of1 /> },
      { path: "creator/:address", element: <Creator /> },
      { path: ":shortName/:address/claim/:code", element: <Claim /> },
      { path: ":shortName/:address/:tokenId", element: <TokenDetail /> },
      { path: ":shortName/:address", element: <PublicMint /> },
    ],
  },
]);
